import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15bd8cef"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=15bd8cef&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/ab.farescraper.com/components/AppHeader.vue').default,HomeHero: require('/home/forge/ab.farescraper.com/components/HomeHero.vue').default,GoogleAdSense: require('/home/forge/ab.farescraper.com/components/GoogleAdSense.vue').default,HomeSteps: require('/home/forge/ab.farescraper.com/components/HomeSteps.vue').default,HomeContentBlockFlightGorilla: require('/home/forge/ab.farescraper.com/components/HomeContentBlockFlightGorilla.vue').default,HomeContentBlockFlightSearchDirect: require('/home/forge/ab.farescraper.com/components/HomeContentBlockFlightSearchDirect.vue').default,HomeContentBlockFareScraper: require('/home/forge/ab.farescraper.com/components/HomeContentBlockFareScraper.vue').default,HomeContentBlockCheapflights: require('/home/forge/ab.farescraper.com/components/HomeContentBlockCheapflights.vue').default,HomeContentBlockHotelSearchDirect: require('/home/forge/ab.farescraper.com/components/HomeContentBlockHotelSearchDirect.vue').default,AppFooter: require('/home/forge/ab.farescraper.com/components/AppFooter.vue').default,AppMobileFooter: require('/home/forge/ab.farescraper.com/components/AppMobileFooter.vue').default,ModalNewsletter: require('/home/forge/ab.farescraper.com/components/ModalNewsletter.vue').default,DebugBar: require('/home/forge/ab.farescraper.com/components/DebugBar.vue').default})
